import { useEffect, useState } from "react";
import { useTranslate } from "@refinedev/core";
import styled from "styled-components";
import { TDot } from "./Autopilot/Autopilot.styled";

const ROTATING_MESSAGE_KEYS = [
  "media.autopilot.steps.final.rotatingMessages.checkingPacing",
  "media.autopilot.steps.final.rotatingMessages.everyScene",
  "media.autopilot.steps.final.rotatingMessages.lettingBreathe",
  "media.autopilot.steps.final.rotatingMessages.tighteningTransitions",
  "media.autopilot.steps.final.rotatingMessages.listeningVoiceover",
  "media.autopilot.steps.final.rotatingMessages.energyCheck",
  "media.autopilot.steps.final.rotatingMessages.trimmingSlowParts",
  "media.autopilot.steps.final.rotatingMessages.freshEyes",
  "media.autopilot.steps.final.rotatingMessages.smallTweaks",
  "media.autopilot.steps.final.rotatingMessages.nothingOutOfPlace",
  "media.autopilot.steps.final.rotatingMessages.oneMoreLook",
] as const;

export const FinalThinking: React.FC<{ isActive: boolean }> = ({
  isActive,
}) => {
  const t = useTranslate();
  const [msgVisible, setMsgVisible] = useState(true);
  const [msgIndex, setMsgIndex] = useState(0);

  useEffect(() => {
    if (!isActive) return;
    let innerTimeout: ReturnType<typeof setTimeout>;
    const iv = setInterval(() => {
      setMsgVisible(false);
      innerTimeout = setTimeout(() => {
        setMsgIndex((p) => (p + 1) % ROTATING_MESSAGE_KEYS.length);
        setMsgVisible(true);
      }, 300);
    }, 4000);
    return () => {
      clearInterval(iv);
      clearTimeout(innerTimeout);
    };
  }, [isActive]);

  return (
    <FinalThinkingWrap>
      <TDot $delay={0} />
      <TDot $delay={150} />
      <TDot $delay={300} />
      <FinalThinkingMsg $visible={msgVisible}>
        {t(ROTATING_MESSAGE_KEYS[msgIndex])}
      </FinalThinkingMsg>
    </FinalThinkingWrap>
  );
};

const FinalThinkingWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  margin-top: 6px;
`;

const FinalThinkingMsg = styled.span<{ $visible: boolean }>`
  font-size: 12px;
  color: #9ca3af;
  font-style: italic;
  opacity: ${(p) => (p.$visible ? 1 : 0)};
  transition: opacity 0.3s ease;
  margin-left: 4px;
`;
